import { render, staticRenderFns } from "./LaporanTraining.vue?vue&type=template&id=58d42d15&"
import script from "./LaporanTraining.vue?vue&type=script&lang=js&"
export * from "./LaporanTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LaporanTraining.vue"
export default component.exports